import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import Blog from './components/Blog';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

// ==========================================
// NUEVO COMPONENTE: ScrollToTop
// ==========================================
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Desplaza la ventana al inicio (0, 0) cada vez que cambia la ruta
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Componente para controlar la visibilidad
const VisibilityController = ({ children, showOnFirstLoad = false }) => {
  const [hasNavigated, setHasNavigated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Si no es la ruta inicial ("/"), significa que ha navegado
    if (location.pathname !== '/') {
      setHasNavigated(true);
    }
  }, [location.pathname]);

  // Mostrar si: es de primera carga O si ya ha navegado
  if (showOnFirstLoad || hasNavigated) {
    return children;
  }

  return null;
};

const Home = () => (
  <>
    <Hero />
    <VisibilityController showOnFirstLoad={true}>
      <About />
    </VisibilityController>
    <VisibilityController>
      <Services />
    </VisibilityController>
    <VisibilityController>
      <Testimonials />
    </VisibilityController>
    <VisibilityController>
      <Blog />
    </VisibilityController>
    <VisibilityController>
      <Gallery />
    </VisibilityController>
    <VisibilityController showOnFirstLoad={true}>
      <Contact />
    </VisibilityController>
  </>
);

const Nosotros = () => (
  <>
    <div className="min-h-screen pt-20 bg-white">
      <About />
      <Testimonials />
    </div>
    <Contact />
  </>
);

const ServiciosPage = () => (
  <>
    <div className="min-h-screen pt-20 bg-white">
      <Services />
      <Testimonials />
    </div>
    <Contact />
  </>
);

const BlogPage = () => (
  <>
    <div className="min-h-screen pt-20 bg-white">
      <Blog />
    </div>
    <Contact />
  </>
);

const Galeria = () => (
  <>
    <div className="min-h-screen pt-20 bg-white">
      <Gallery />
    </div>
    <Contact />
  </>
);

const Contacto = () => (
  <>
    <div className="min-h-screen pt-20 bg-white">
      <Contact />
    </div>
  </>
);

// Componente principal de la aplicación
function AppContent() {
  return (
    <div className="App">
      {/* 👇 Insertamos ScrollToTop aquí para que se ejecute en cada cambio de ruta */}
      <ScrollToTop />
      
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/nosotros" element={<Nosotros />} />
        <Route path="/servicios" element={<ServiciosPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/galeria" element={<Galeria />} />
        <Route path="/contacto" element={<Contacto />} />
      </Routes>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AnimatePresence mode="wait">
        <AppContent />
      </AnimatePresence>
    </Router>
  );
}

export default App;